<div
  class="editable"
  *ngIf="!editing"
  (click)="edit()"
  (focus)="edit()"
  tabindex="0"
  [ngClass]="{ error: error, readonly: readonly, 'mat-empty-cell-overlay': emptyCellOverlay }"
  [class.locked]="fieldDef.locked"
  [matTooltip]="showTip"
  data-cy="app-editable-datetime-read"
>
  <div *ngIf="isNestedField; else text">
    <div *ngFor="let item of value; let last = last">
      {{ item.label | date: 'MM/dd/yyyy' }}<span *ngIf="!last">, </span>
    </div>
  </div>

  <ng-template #text>
    {{ value | date: 'MM/dd/yyyy' }}
  </ng-template>
</div>
<div class="flex" *ngIf="editing" tabindex="0">
  <input
    matInput
    [matDatepicker]="dtPicker"
    [ngModel]="value"
    [placeholder]="showEmptyHolder ? 'YYYY-MM-DD' : fieldDef.label"
    (dateChange)="onDateChange($event)"
    (keyup.enter)="onBlur()"
    (blur)="onBlur()"
    [readonly]="!showEmptyHolder"
    [disabled]="isDisabled"
    [matTooltip]="showTip"
  />
  <mat-datepicker-toggle matSuffix [for]="dtPicker" focused></mat-datepicker-toggle>
  <mat-datepicker
    #dtPicker
    [disabled]="isDisabled || !editing"
    (closed)="hideEdit()"
    [calendarHeaderComponent]="customHeader"
  >
  </mat-datepicker>
</div>
